import { useFormikContext } from "formik";
import * as React from "react";
import { useCallback } from "react";
const NestedForm = ({ children }) => {
  const { handleSubmit, handleReset } = useFormikContext();
  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleSubmit(e);
    },
    [handleSubmit]
  );
  const onReset = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleReset(e);
    },
    [handleReset]
  );
  return /* @__PURE__ */ React.createElement("form", { onSubmitCapture: onSubmit, onResetCapture: onReset }, children);
};
export default NestedForm;
